import { Ajax } from "cnetong-core-frontend";
export default Ajax;
